import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  API_ADMIN_TOKEN_EXCHANGE,
  API_GET_MY_PERMISSIONS,
  API_GET_USER_DETAILS,
  FORGET_PASSWORD,
  LOGIN,
  LOGOUT,
} from "../../../shared/routes/auth.routes";
import { Client } from "../../api-client";

const config = {
  name: "auth",
};

export const requestAdminLogin: any = createAsyncThunk(
  `${config.name}/requestAdminLogin`,
  async (body: { token: string }) => {
    return Client.post(API_ADMIN_TOKEN_EXCHANGE, body);
  }
);

export const requestLogin: any = createAsyncThunk(
  `${config.name}/requestLogin`,
  async (payload: any) => {
    return Client.post(LOGIN, payload);
  }
);

export const getUsersDetails: any = createAsyncThunk(
  `${config.name}/getUsersDetails`,
  async (payload: any) => {
    return Client.post(API_GET_USER_DETAILS, payload);
  }
);

export const getMyPermissions: any = createAsyncThunk(
  `${config.name}/getMyPermissions`,
  async () => {
    const response = await Client.get(API_GET_MY_PERMISSIONS);
    if (!response.data?.success) {
      throw new Error(response.data?.message || "Unable to load permissions");
    }
    return response.data;
  }
);

export const requestLogout: any = createAsyncThunk(
  `${config.name}/requestLogout`,
  async (params: any) => {
    return Client.post(LOGOUT, params);
  }
);

export const requestForgetPassword: any = createAsyncThunk(
  `${config.name}/requestForgetPassword`,
  async (payload: any) => {
    return Client.post(FORGET_PASSWORD, payload);
  }
);


export const authReducer = createSlice({
  name: config.name,
  initialState: {
    loggingIn: false,
    user: {} as any,
    accessToken: null as any,
    refreshToken: null as any,
    authToken: null as any,
    myPermissions: [] as any,
    permissionsStatus: "idle" as "idle" | "loading" | "succeeded" | "failed"
  },
  reducers: {

    setAdminToken: (state, action) => {
      state.myPermissions = [];
      state.permissionsStatus = "idle";
      state.accessToken = action.payload;
      localStorage.setItem("accessToken", state.accessToken || "");
    },
    setUserProfile: (state, action) => {
      state.user = action.payload;
    },
    logout: (state) => {
      localStorage.clear();
      sessionStorage.clear();
      state.accessToken = null;
      state.myPermissions =[] as any;
      state.permissionsStatus = "idle";
      state.loggingIn = false;
      state.user = {} as any;
      window.location.reload();
    },
    // mockLogin: (state) => {
    //   state.loggingIn = false;
    //   state.accessToken =
    //     "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJFUi1xbWZfVXBFSW5xOVh3T1l4ak9VR2VIQlN3aDV3WERFS1pBWHBmQ1pzIn0.eyJleHAiOjE2NTcwNDU0NzIsImlhdCI6MTY1NzAwOTQ3MiwianRpIjoiNmVhODk5NDItMjM1MC00Y2E4LWFmYTctMDgxZGQ0M2FmOGY4IiwiaXNzIjoiaHR0cDovL2tleWNsb2FrLmthZm9vLmluL2F1dGgvcmVhbG1zL29jZWFuZWVyaW5nIiwiYXVkIjpbInJlYWxtLW1hbmFnZW1lbnQiLCJhY2NvdW50Il0sInN1YiI6Ijk2MTIwNmJhLWZkODEtNGI5Ni05NjU3LWQ5ODIwNDFlNzA1NSIsInR5cCI6IkJlYXJlciIsImF6cCI6ImF0aGVuYTIiLCJzZXNzaW9uX3N0YXRlIjoiNzgxY2IxYjQtNWYzYy00YWE2LThkN2YtODlkZjJkNDQ4MjVmIiwiYWNyIjoiMSIsImFsbG93ZWQtb3JpZ2lucyI6WyIqIl0sInJlYWxtX2FjY2VzcyI6eyJyb2xlcyI6WyJvZmZsaW5lX2FjY2VzcyIsImRlZmF1bHQtcm9sZXMtb2NlYW5lZXJpbmciLCJ1bWFfYXV0aG9yaXphdGlvbiJdfSwicmVzb3VyY2VfYWNjZXNzIjp7InJlYWxtLW1hbmFnZW1lbnQiOnsicm9sZXMiOlsidmlldy1yZWFsbSIsInZpZXctaWRlbnRpdHktcHJvdmlkZXJzIiwibWFuYWdlLWlkZW50aXR5LXByb3ZpZGVycyIsImltcGVyc29uYXRpb24iLCJyZWFsbS1hZG1pbiIsImNyZWF0ZS1jbGllbnQiLCJtYW5hZ2UtdXNlcnMiLCJxdWVyeS1yZWFsbXMiLCJ2aWV3LWF1dGhvcml6YXRpb24iLCJxdWVyeS1jbGllbnRzIiwicXVlcnktdXNlcnMiLCJtYW5hZ2UtZXZlbnRzIiwibWFuYWdlLXJlYWxtIiwidmlldy1ldmVudHMiLCJ2aWV3LXVzZXJzIiwidmlldy1jbGllbnRzIiwibWFuYWdlLWF1dGhvcml6YXRpb24iLCJtYW5hZ2UtY2xpZW50cyIsInF1ZXJ5LWdyb3VwcyJdfSwiYXRoZW5hMiI6eyJyb2xlcyI6WyJhZG1pbiIsInVzZXIiXX0sImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoicHJvZmlsZSBlbWFpbCIsInNpZCI6Ijc4MWNiMWI0LTVmM2MtNGFhNi04ZDdmLTg5ZGYyZDQ0ODI1ZiIsInBncm91cCI6IjU1NTNmOTY2LTIzMTEtNDliMC1hNjhmLWJlZTNjOTMzMzgyZSIsImVtYWlsX3ZlcmlmaWVkIjpmYWxzZSwibmFtZSI6IkNsYXJrIG1haGVzaHdhcmkiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJjYW1iYXl0ZXN0QGdtYWlsLmNvbSIsImdpdmVuX25hbWUiOiJDbGFyayIsImZhbWlseV9uYW1lIjoibWFoZXNod2FyaSIsImVtYWlsIjoiY2FtYmF5dGVzdEBnbWFpbC5jb20iLCJncm91cCI6WyIvQ2FtYmF5Il19.kPfZSdW7vdepsXivzTv4IkqJDajF6tOx6hiZZUdgO56c0xVLVGa9gVd6Cxq7QqiNbMYV6utZDC_FZ1hEeXGv4IP-hthYVDunzLUFKVJhMPYdtxXAET0-lzNP6JUQe9_swPTx-IEUyLXUGsDyPgQYYN0UvQ3hOqo3gTuyMcl5qQTy7JQqWimZYKHyz59EEdxKHi8xTVF0oHOHi_WXlK-AD_mtBbfHQXLfwH6GlrGRqvYNrnLhdmpb0HUI_-QSGp4xLv7NP7KQCFxEEAhfsfPkRZScYSu5LXYiWGNlpItKP0_snbwn5DJ3YEbEDhL9wThYgNWQwVjTczp4SkCMKYvxmw";
    //   localStorage.setItem("accessToken", state.accessToken);
    //   state.user = {
    //     username: 'demouser',
    //     firstName: "Demo",
    //     lastName: "User",
    //     phoneNumber: "1234567890",
    //     id: "345162372ti23t2t1yq23t",
    //     email: 'aa@gg.com',
    //     enabled: true
    //   };
    // },
  },
  extraReducers(builder) {
    builder
      .addCase(requestLogin.pending, (state) => {
        state.loggingIn = true;
        state.user = {} as any;
      })
      .addCase(requestLogin.fulfilled, (state, action) => {
        state.loggingIn = false;
        state.accessToken = action?.payload?.data?.data?.accessToken;
        state.user = action?.payload?.data?.data?.userDetails;
        localStorage.setItem("accessToken", action?.payload?.data?.data?.accessToken);
        try {
          const uid = action?.payload?.data?.data?.userDetails?.id || action?.payload?.data?.data?.userDetails?.userId;
          if (uid) localStorage.setItem("userId", uid);
        } catch (e) {}
      })
      .addCase(requestLogin.rejected, (state) => {
        state.loggingIn = false;
        state.user = {} as any;
      })

      .addCase(requestLogout.pending, (state) => {
        state.loggingIn = true;
        state.user = {} as any;
      })
      .addCase(requestLogout.fulfilled, (state, _action) => {
        state.loggingIn = false;
        state.user = {} as any;
        state.accessToken = null;
        state.refreshToken = null;
        state.authToken = null;
        state.myPermissions =[] as any;
        state.permissionsStatus = "idle";
      })
      .addCase(requestLogout.rejected, (state) => {
        state.loggingIn = false;
        state.user = {} as any;
      })

      .addCase(getMyPermissions.pending, (state) => {
        state.permissionsStatus = "loading";
        state.myPermissions = [] as any;
      })
      .addCase(getMyPermissions.fulfilled, (state, action) => {
        state.permissionsStatus = "succeeded";
        state.myPermissions = action?.payload?.data ?? [];
      })
      .addCase(getMyPermissions.rejected, (state) => {
        state.permissionsStatus = "failed";
        state.myPermissions = [] as any;
      })
  },
});

export const { logout,setAdminToken ,setUserProfile} = authReducer.actions;
export default authReducer.reducer;

